/**
 * KnowledgeSkeleton — pillar-page placeholder. Two sections mirror the live
 * layout. 200ms delay so fast loads never flicker.
 */

import { SkeletonCardGrid } from '../../components/Skeleton.tsx';
import { useDelayedFlag } from '../../hooks/useDelayedFlag.ts';

export function KnowledgeSkeleton() {
  const show = useDelayedFlag(true);
  if (!show) return <div style={{ minHeight: '40vh' }} />;
  return (
    <>
      <section className="catalog-section">
        <SkeletonCardGrid count={6} />
      </section>
      <section className="catalog-section">
        <SkeletonCardGrid count={3} />
      </section>
    </>
  );
}
